import { render, staticRenderFns } from "./IncidentBarChart.vue?vue&type=template&id=cd0ca478&"
import script from "./IncidentBarChart.vue?vue&type=script&lang=js&"
export * from "./IncidentBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports